import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import {
  NumberBox,
  SelectBox,
  Template,
  TextArea,
  TextBox,
  DateBox,
} from "devextreme-react";
import DataGrid, {
  Column,
  HeaderFilter,
  Scrolling,
  SearchPanel,
  Paging,
  Editing,
  Lookup,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import {
  AssetSubStatus,
  CurrencyIcon,
  DefaultDateFormat,
  PrecisionFormats,
  Features,
} from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { useLocation, useNavigate } from "react-router-dom";
import "./../../../App.css";
import Modal from "react-modal";
import moment from "moment";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  askConfirmation,
  showResponseMessage,
  showWarningMessage,
} from "../../../helper/message";
import JoditEditor from "jodit-react";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi";
import Swal from "sweetalert2";

var levelInputDropdown = [
  { id: 1, name: "L1" },
  { id: 2, name: "L2" },
  { id: 3, name: "L3" },
  { id: 4, name: "L4" },
  { id: 5, name: "L5" },
  { id: 6, name: "L6" },
  { id: 7, name: "L7" },
  { id: 8, name: "L8" },
  { id: 9, name: "L9" },
  { id: 10, name: "L10" },
];

const transportationTypeList = [
  { id: 1, name: "VSE" },
  { id: 2, name: "Vendor" },
];

const serviceTypeList = [
  { id: 1, name: "Per Day" },
  { id: 2, name: "Per Hour" },
  { id: 3, name: "Per Month" },
];

export const employees = [
  {
    Id: 1,
    Name: "John",
    Value: "Heart",
  },
  {
    Id: 1,
    Name: "John",
    Value: "Heart",
  },
];

// const orders = [
//   { id: 1, statusId: 1, customer: 'John Doe' },
//   { id: 2, statusId: 2, customer: 'Jane Smith' },
// ];

// const statusLookup = [
//   { id: 1, name: 'Pending' },
//   { id: 2, name: 'Completed' },
//   { id: 3, name: 'Shipped' },
// ];

let tempRate = [];
let row = 1;

export default function AddAssetHireComponent(props) {
  const user = useSelector((state) => state.user.data);
  const location = useLocation();
  const navigate = useNavigate();

  const [state, setState] = useState({
    isSubmitted: false,
    isSavingAsDraft: false,
    isApproving: false,
    assetQuotationId: location?.state?.data?.requestQuotationId ?? 0,
    quotationTypeId: location?.state?.data?.quotationTypeId ?? 0,
    quotationIndentNo: location?.state?.data?.quotationIndentNo ?? 0,
    fromProjectId: 0,
    fromProjectName: "",
    fromLocationName: "",
    toProjectId: 0,
    toProjectName: "",
    toLocationName: "",
    note: "",
    isVendorModalOpen: false,
    rowData: null,
    remark: "",
    fromId: user?.userDepartmentId ?? 0,
    requestedDate:
      moment(new Date())
        .format(DefaultDateFormat.SqlDateTimeFullFormat)
        .toString() ?? "",
    userId: 0,
    isValid: false,
    workflowCategoryId: 0,
    workflowDepartmentId: 0,
    workflowId: 0,
    vendorId: 0,
    quotationCharges: 0,
    quotationNo: "",
    quotationDate: "",
    statusId: 0,
    levelId: 0,
    levelName: "",
    modelNo: "",
    gst: 0,
    totalAmount: 0,
    transportationTypeId: 0,
    transportationTypeName: "",
  });

  const [errors, setErrors] = useState({
    //userValidation: "",
    //fromProjectValidation: "",
    toProjectValidation: "",
    noteValidation: "",
    vendorValidation: "",
    //quotationNoValidation: "",
    quotationChargesValidation: "",
    //quotationDateValidation: "",
    levelValidation: "",
    fileNameValidation: "",
    gstValidation: "",
    totalAmountValidation: "",
    modelNoValidation: "",
    transportationTypeValidation: "",
  });

  const [assetQuotationSubDataSourceLst, setAssetQuotationSubDataSourceLst] =
    useState([]);
  const [fromProjectDropdown, setFromProjectDropdown] = useState([]);
  const [toProjectDropdown, setToProjectDropdown] = useState([]);
  const [userDropdown, setUserDropdown] = useState([]);
  const [workflowCategoryDropdown, setWorkflowCategoryDropdown] = useState([]);
  const [workflowData, setWorkflowData] = useState([]);
  const [assetRequestApproversByWorkflow, setAssetRequestApproversByWorkflow] =
    useState([]);
  const [assetRequestApprovers, setAssetRequestApprovers] = useState([]);
  const [vendorDropdown, setvendorDropdown] = useState([]);
  const [assetQuotationVendorLst, setAssetQuotationVendorLst] = useState([]);
  const [levelDropdown, setLevelDropdown] = useState([]);
  const [baseLevelDropdown, setBaseLevelDropdown] = useState([]);
  const [assetAttachment, setAssetAttachment] = useState({
    documentTypeId: 0,
    documentTypeName: "",
    fileTypeName: "",
    fileName: "",
    fileUrl: "",
    fileData: "",
    extension: "",
    fileSize: 0,
    isIssueDateEnable: false,
    issueDate: "",
    isExpiryDateEnable: false,
    expiryDate: "",
    isReminderAlertEnable: false,
    reminderAlertDays: 0,
    remark: "",
    isUploaded: false,
    uploadedTemporaryAttachmentLst: [],
    //uploadedTemporaryAttachmentLst: stateData !== null ? stateData.assetRequestAttachments ?? [] : [],
    assetRequestId: 0,
  });
  const [files, setFiles] = useState([]);
  const editor = useRef(null);
  const [content, setContent] = useState("");
  const [quotationVendorLineItemLst, setQuotationVendorLineItemLst] = useState(
    []
  );
  const [quotationVendorLineItemConfig, setQuotationVendorLineItemConfig] =
    useState([]);
  const [quotationAllVendorLineItemLst, setQuotationAllVendorLineItemLst] =
    useState([]);
  const refDataGrid = useRef(null);
  const refDataGridColumnsConfig = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Quotation`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    debugger;
    if (state?.workflowCategoryId > 0) {
      GetWorkFlowForApprovers(
        state?.workflowCategoryId,
        state?.toProjectId,
        state?.departmentId
      );
    } else {
      GetWorkFlowForApprovers(
        state.workflowCategoryId,
        state?.toProjectId,
        state?.departmentId
      );
    }
  }, [
    state?.fromProjectId,
    state?.workflowCategoryId,
    user?.workflowDepartmentId,
  ]);

  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getUserDropdown();
      }, 0);
      setTimeout(async () => {
        await getFromProjectDropdown();
      }, 0);
      setTimeout(async () => {
        await getToProjectDropdown();
      }, 0);
      // setTimeout(async () => {
      //   await getWorkflowCategory();
      // }, 0);
      setTimeout(async () => {
        await getQuotationAllVendorLineItems();
      });
      setTimeout(async () => {
        await getAssetQuotationSub(state.assetQuotationId);
      }, 0);
      setTimeout(async () => {
        await getAssetQuotation(state.assetQuotationId);
      }, 0);
      setTimeout(async () => {
        await getAssetQuotationVendor(state.assetQuotationId);
      }, 0);

      setTimeout(async () => {
        await getVendorDropdown();
      }, 0);
      setTimeout(async () => {
        await getLevelDropdown();
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getFromProjectDropdown = async () => {
    try {
      let body = { companyId: user?.companyId };
      const response = await vishwamApi.getProjectList(body);
      setFromProjectDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getToProjectDropdown = async () => {
    try {
      let body = { companyId: user?.companyId };
      const response = await vishwamApi.getProjectList(body);
      setToProjectDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getUserDropdown = async () => {
    try {
      const response = await vishwamApi.getUserList();
      setUserDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getVendorDropdown = async () => {
    try {
      const response = await vishwamApi.getVendorList(user?.companyId);
      setvendorDropdown(
        response?.data?.filter((f) => f.isActive === true) ?? []
      );
      //setvendorDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getLevelDropdown = async () => {
    try {
      const levelIds = new Set(
        assetQuotationVendorLst?.map((a1) => a1.quotationLevelId)
      );
      const filteredArr2 = levelInputDropdown?.filter(
        (a2) => !levelIds.has(a2.id)
      );
      setLevelDropdown(filteredArr2 ?? []);
      setBaseLevelDropdown(levelInputDropdown);
      //setLevelDropdown(levelInputDropdown ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getWorkflowCategory = async (projectId, departmentId) => {
    try {
      let body = {
        formId: props.featurePermission.featureId,
        projectId: projectId,
        departmentId: user.userDepartmentId,
      };
      debugger;
      const response = await assetService.getWorkflowGroup(body);
      setWorkflowCategoryDropdown(response?.data);
      if (response?.data.length >= 1) {
        setState((prev) => ({
          ...prev,
          workflowCategoryId: response?.data[0].workflowCategoryId,
          workflowId: response?.data[0].workflowId,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GetWorkFlowForApprovers = async (
    formCategoryId,
    projectId,
    departmentId
  ) => {
    try {
      let body = {
        formId: props.featurePermission.featureId,
        categoryId: formCategoryId || 0,
        projectId: projectId || 0,
        departmentId: departmentId || 0,
      };
      if (
        body.formId > 0 &&
        body.categoryId > 0 &&
        body.projectId > 0 &&
        body.departmentId > 0
      ) {
        debugger;
        const response = await vishwamApi.getWorkFlowForApprovalForAsset(body);        
        //console.log(JSON.stringify(response));
        setWorkflowData(response);
        const stagesWithApprovers = response?.stages
          ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
          ?.map((stage) => ({
            actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
            approvers: stage?.approvers,
          }));
        const Approvers = response?.stages
          ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
          ?.flatMap((stage) =>
            stage?.approvers?.map((approver) => ({
              actionTypeId: stage?.actionTypeId,
              userId: approver?.userId,
              canEdit: approver?.canEdit,
              stageId: stage?.index,
            }))
          );
        setAssetRequestApprovers(Approvers);
        setAssetRequestApproversByWorkflow(stagesWithApprovers);
        // console.log(Approvers);
      }
    } catch (error) {
      console.log("Error getDepartmentDropdown===>", error);
    }
  };

  const getAssetQuotation = async (assetQuotationId) => {
    try {
      let body = {
        quotationRequestId: assetQuotationId,
        statusId: 0,
        userId: user.userId,
        quotationTypeId: state.quotationTypeId,
      };
      const response = await assetService.assetQuotationList(body);
      //console.log(response?.data);
      setTimeout(async () => {
        await getWorkflowCategory(response?.data[0]?.toProjectId ?? 0);
      }, 0);

      setContent(response?.data[0]?.quoteContent ?? "");
      setState((prev) => ({
        ...prev,
        userId: response?.data[0]?.toId ?? 0,
        fromId: response?.data[0]?.fromId ?? 0,
        toId: state.toId > 0 ? state.toId : response?.data[0]?.toId,
        fromProjectId:
          state.fromProjectId > 0
            ? state.fromProjectId
            : response?.data[0]?.fromProjectId,
        fromProjectName: response?.data[0]?.fromProjectName ?? "",
        fromLocationName: response?.data[0]?.fromLocation ?? "",
        fromDepartmentId: response?.data[0]?.fromDepartmentId ?? 0,
        fromDepartment: response?.data[0]?.fromDepartment ?? "",
        toProjectId: response?.data[0]?.toProjectId ?? 0,
        toProjectName: response?.data[0]?.toProjectName ?? "",
        toLocationName: response?.data[0]?.toLocation ?? "",
        toDepartmentId: response?.data[0]?.toDepartmentId ?? 0,
        toDepartment: response?.data[0]?.toDepartment ?? "",
        note: response?.data[0]?.note ?? "",
        isValid: response?.data[0]?.isValid ?? false,
        workflowCategoryId: response?.data[0]?.categoryId ?? 0,
        workflowId: response?.data[0]?.workflowId ?? 0,
        workflowDepartmentId: response?.data[0]?.fromDepartmentId ?? 0,
        statusId: response?.data[0]?.statusId ?? 0,
        departmentId: response?.data[0]?.departmentId ?? 0,
        department: response?.data[0]?.department ?? "",
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetQuotationSub = async (assetQuotationId) => {
    try {
      let body = {
        quotationRequestId: assetQuotationId,
        statusId: 0,
        quotationTypeId: state.quotationTypeId,
      };
      const response = await assetService.assetQuotationById(body);

      setAssetQuotationSubDataSourceLst(
        response?.data?.assetQuotationSub[0] ?? []
      );
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const getAssetQuotationVendor = async (assetQuotationId) => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await assetService.getAssetQuotationVendors(
        assetQuotationId,
        0
      );
      setAssetQuotationVendorLst(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const getQuotationAllVendorLineItems = async () => {
    try {
      var request = {};
      request.quotationRequestId = state.assetQuotationId;
      request.vendorId = 0;
      const response = await assetService.getQuotationAllVendorLineItems(
        request
      );
      //console.log(response?.data);
      setQuotationAllVendorLineItemLst(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const getQuotationVendorLineItems = async (vendorId) => {
    try {
      var request = {};
      request.quotationRequestId = state.assetQuotationId;
      request.vendorId = vendorId;
      const response = await assetService.getQuotationVendorLineItems(request);
      //console.log(response?.data);

      if (state.quotationTypeId === 1) {
        setQuotationVendorLineItemLst(
          response?.data?.quotationVendorLineItem.filter(e => e.lineItemMasterId !== 7 && e.lineItemMasterId !== 8) ?? []
        );
      }

      if (state.quotationTypeId === 2) {
        setQuotationVendorLineItemLst(
          response?.data?.quotationVendorLineItem ?? []
        );
      }

      // setQuotationVendorLineItemLst(
      //     response?.data?.quotationVendorLineItem ?? []
      //   );

      setQuotationVendorLineItemConfig(
        response?.data?.quotationVendorLineItemConfig ?? []
      );
      setAssetAttachment((prev) => ({
        ...prev,
        uploadedTemporaryAttachmentLst:
          response?.data?.quotationVendorLineItemAttachmentResponse,
      }));

      // console.log(response?.data?.quotationVendorLineItemConfig);
      // console.log(response?.data?.quotationVendorLineItem);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const isValidData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      //err.userValidation = "";
      //err.fromProjectValidation = "";
      err.toProjectValidation = "";
      err.noteValidation = "";

      // if (state.userId === 0) {
      //   err.userValidation = "Please select To.";
      //   isValid = false;
      // }
      // if (state.fromProjectId === 0) {
      //     err.fromProjectValidation = "Please select from project.";
      //     isValid = false;
      // }
      if (state.note == "") {
        err.noteValidation = "Please enter note.";
        isValid = false;
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleFileChange = async (e) => {
    try {
      const assetAttachment = Array.from(e.target.files);
      const newAttachmentPromises = assetAttachment.map(async (file) => {
        const base64 = await getBase64(file);
        return {
          noOfRows: Math.random().toString(16).slice(2),
          id: 0,
          assetFileName: file.name,
          fileName: file.name,
          fileSize: file.size,
          fileTypeId: 0,
          fileTypeName: "",
          filePath: "",
          fileUrl: "",
          fileData: base64,
          fileType: file.type,
          uploadDate: "",
          issueDate: "",
          expiryDate: "",
          reminderAlertDays: 0,
          remark: "",
        };
      });

      const newAttachments = await Promise.all(newAttachmentPromises);
      setAssetAttachment((prev) => {
        const existingList = prev.uploadedTemporaryAttachmentLst || [];
        return {
          ...prev,
          uploadedTemporaryAttachmentLst: [...existingList, ...newAttachments],
        };
      });
      setFiles((prevState) => [...prevState, ...assetAttachment]);

      let err = { ...errors };
      err.fileNameValidation = "";
      setErrors(err);
    } catch (error) {
      console.error(error);
    } finally {
      setAssetAttachment((prev) => ({ ...prev, isUploaded: false }));
    }
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) return resolve("");

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileRemove = (index) => {
    var newfiles = assetAttachment.uploadedTemporaryAttachmentLst?.filter(
      (_, i) => i !== index
    );
    setAssetAttachment((prev) => ({
      ...prev,
      uploadedTemporaryAttachmentLst: newfiles,
    }));
  };

  const handleOnSubmitAssetQuotationDetails = async (e) => {
    e.preventDefault();
    try {
      if (assetQuotationVendorLst?.length === 0) {
        let alertMessage = `Please select vendor`;
        let isConfirmed = await showWarningMessage(alertMessage, "Warning");
        return;
      }
      var level1Vendor =
        assetQuotationVendorLst?.filter((e) => e.quotationLevelId === 1)
          .length ?? 0;
      if (level1Vendor === 0) {
        let alertMessage = `Please add vendor with L1`;
        let isConfirmed = await showWarningMessage(alertMessage, "Warning");
        return;
      }

      var level1Vendor =
        assetQuotationVendorLst?.filter((e) => e.quotationLevelId === 1)
          .length ?? 0;
      if (level1Vendor === 0) {
        let alertMessage = `Please add vendor with L1`;
        let isConfirmed = await showWarningMessage(alertMessage, "Warning");
        return;
      }

      if (isValidData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>${
          state.quotationTypeId === 1
            ? `Are you sure want to add asset purchase request details?`
            : `Are you sure want to add asset hire request details?`
        }</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSavingAsDraft: true }));

        let workflowCategory = {};
        workflowCategory.formId = props.featurePermission.featureId;
        workflowCategory.categoryId = state.workflowCategoryId;
        workflowCategory.projectId = state.toProjectId;
        workflowCategory.departmentId = state.workflowDepartmentId; // user.userDepartmentId;

        let body = {
          assetQuotationId: state.assetQuotationId,
          fromProjectId: state.fromProjectId,
          fromLocationName: state.fromLocationName,
          toProjectId: state.toProjectId,
          toLocationName: state.toLocationName,
          fromId: state.fromId,
          requestedDate: state.requestedDate,
          note: state.note,
          userId: user?.userId,
          toId: state.userId,
          statusId:
            state.quotationTypeId === 1
              ? AssetSubStatus.RequestForAssetPurchaseInDraftMode
              : AssetSubStatus.RequestForAssetServiceOrderInDraftMode,
          requestNo: state?.quotationIndentNo,
          formId: props.featurePermission.featureId,
          applicationId: 3,
          workflowId: state.workflowId,
          formName: "Asset Quotation Hire",
          departmentId: state.workflowDepartmentId,
          categoryId: state.workflowCategoryId,
          WorkflowCategoryRequest: workflowCategory,
          quoteContent: content,
          isLoginUserRequester: assetRequestApprovers?.[0]?.actionTypeId === 8 ? false : true,
        };

        const response = await assetService.updateAssetPurchaseQuotationDetails(
          body
        );
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isSavingAsDraft: false }));
        if (response?.isSuccess) {
          await getAssetQuotation(state.assetQuotationId);
          await getAssetQuotationSub(state.assetQuotationId);
          window.location.href =
            state.quotationTypeId === 1
              ? `/RequestAssetPurchase`
              : `/RequestAssetHire`;
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSavingAsDraft: false }));
      console.log(error);
    }
  };

  const handleOnDeleteAssetVendor = async (e, assetQuotationId) => {
    e.preventDefault();
    try {
      let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to delete asset vendor?</span>`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );
      if (!isConfirmed) return;
      setState((prev) => ({ ...prev, isSavingAsDraft: true }));

      const response = await assetService.deleteAssetQuotationVendors(
        assetQuotationId
      );
      isConfirmed = await showResponseMessage(response);
      setState((prev) => ({ ...prev, isSavingAsDraft: false }));
      if (response?.isSuccess) {
        await getAssetQuotationVendor(state.assetQuotationId);
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSavingAsDraft: false }));
      console.log(error);
    }
  };

  const handleOnSubmitAssetQuotationApprovalDetails = async (e) => {
    e.preventDefault();
    try {
      if (isValidData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>${
          state.quotationTypeId === 1
            ? `Are you sure want to update asset purchase request details?`
            : `Are you sure want to update asset hire request details?`
        }</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSavingAsDraft: true }));

        let workflowCategory = {};
        workflowCategory.formId = props.featurePermission.featureId;
        workflowCategory.categoryId = state.workflowCategoryId;
        workflowCategory.projectId = state.toProjectId;
        workflowCategory.departmentId = state?.departmentId; // user.userDepartmentId;

        let body = {
          assetQuotationId: state.assetQuotationId,
          fromProjectId: state.fromProjectId,
          fromLocationName: state.fromLocationName,
          toProjectId: state.toProjectId,
          toLocationName: state.toLocationName,
          fromId: state.fromId,
          requestedDate: state.requestedDate,
          note: state.note,
          userId: user?.userId,
          toId: state.userId,
          statusId:
            state.quotationTypeId === 1
              ? AssetSubStatus.RequestForAssetPurchaseSendForApproval
              : AssetSubStatus.RequestForAssetServiceOrderSendForApproval,
          requestNo: state?.quotationIndentNo,
          formId: props.featurePermission.featureId,
          applicationId: 3,
          workflowId: state.workflowId,
          formName: "Asset Purchase",
          departmentId: state.departmentId,
          categoryId: state.workflowCategoryId,
          WorkflowCategoryRequest: workflowCategory,
          vendorId: state.vendorId,
          vendorName: "",
          quoteContent: content,
          isLoginUserRequester: assetRequestApprovers?.[0]?.actionTypeId === 8 ? false : true,
        };

        const response = await assetService.updateAssetPurchaseQuotationDetails(
          body
        );
        isConfirmed = await showResponseMessage(response);

        let approvalbody = {
                  AssetQuotationPurchaseRequestId: state.assetQuotationId,
                  statusId:
                    state.quotationTypeId === 1
                      ? AssetSubStatus.RequestForAssetPurchaseApproved
                      : AssetSubStatus.RequestForAssetServiceOrderApproved,
                  Remark: "",
                  userId: user?.userId,
                  assetId: [],
                };
        
                const approvalresponse =
                  await assetService.updateAssetQuotationPurchaseRequestStatus(approvalbody);
                if (!response?.isSuccess) {
                  Swal.fire("Error!", `${response?.message}`, "error");
                  setState((prev) => ({ ...prev, isAssetPurchaseApprove: false }));
                  return;
                }

        setState((prev) => ({ ...prev, isSavingAsDraft: false }));
        if (response?.isSuccess) {
          await getAssetQuotation(state.assetQuotationId);
          await getAssetQuotationSub(state.assetQuotationId);
          window.location.href =
            state.quotationTypeId === 1
              ? `/RequestAssetPurchase`
              : `/RequestAssetHire`;
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSavingAsDraft: false }));
      console.log(error);
    }
  };

  const isValidAssetQuotationVendor = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.vendorValidation = "";

      // err.quotationChargesValidation = "";
      // err.levelValidation = "";
      // err.fileNameValidation = "";
      // err.gstValidation = "";
      // err.totalAmountValidation = "";
      // err.modelNoValidation = "";
      // err.transportationTypeValidation = "";

      if (state.vendorId === 0) {
        err.vendorValidation = "Please select vendor.";
        isValid = false;
      }
      // if (!state.quotationCharges || state.quotationCharges === 0) {
      //   err.quotationChargesValidation = "Please enter quotation charges.";
      //   isValid = false;
      // }
      // if (!state.gst || state.quotationChargesgst === 0) {
      //   err.gstValidation = "Please enter gst(%).";
      //   isValid = false;
      // }
      // if (!state.totalAmount || state.totalAmount === 0) {
      //   err.totalAmountValidation = "Please enter total amount.";
      //   isValid = false;
      // }
      // if (state.levelId === 0) {
      //   err.levelValidation = "Please select level.";
      //   isValid = false;
      // }
      // if (assetAttachment.assetFileName === "") {
      //   err.fileNameValidation = "Please select attachment.";
      //   isValid = false;
      // }
      // if (state.modelNo === "") {
      //   err.modelNoValidation = "Please enter model no.";
      //   isValid = false;
      // }
      // if (state.transportationTypeId === 0) {
      //   err.transportationTypeValidation = "Please select transporation type.";
      //   isValid = false;
      // }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnSaveAssetQuotationVendor = async (e) => {
    e.preventDefault();
    try {
      if (isValidAssetQuotationVendor()) {
        let quotationVendorItems =
          refDataGridColumnsConfig.current.instance.option("dataSource");

        let priceExcGst = quotationVendorItems.filter(
          (e) => e.quotationLineItemName === "Price (Exc. GST)"
        );
        let gst = quotationVendorItems.filter(
          (e) => e.quotationLineItemName === "GST%"
        );
        let totalAmount = quotationVendorItems.filter(
          (e) => e.quotationLineItemName === "Total Amount"
        );
        let levelName = quotationVendorItems.filter(
          (e) => e.quotationLineItemName === "Level"
        )[0]?.quotationLineItemValue;
        let levelValue = baseLevelDropdown?.filter((e) => e.name === levelName);

        let transportationTypeName = quotationVendorItems.filter(
          (e) => e.quotationLineItemName === "Transportation Type"
        )[0]?.quotationLineItemValue;

        let transportationTypeValue = transportationTypeList.filter(
          (e) => e.name === transportationTypeName
        );

        let serviceTypeName = quotationVendorItems.filter(
          (e) => e.quotationLineItemName === "Service Type"
        )[0]?.quotationLineItemValue;

        let serviceTypeValue = serviceTypeList.filter(
          (e) => e.name === serviceTypeName
        );

        let hiringQuantity = quotationVendorItems.filter(
          (e) => e.quotationLineItemName === "Hiring Quantity"
        );

        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to add vendor details?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );

        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSubmitted: true }));

        // let body = {
        //   id: assetQuotationVendorLst[0]?.id,
        //   quotationRequestId: state.assetQuotationId,
        //   assetId: 0,
        //   vendorId: state.vendorId,
        //   quotationNo: "",
        //   quotationDate: new Date(),
        //   quotationAmount: state.quotationCharges,
        //   createdBy: user?.userId,
        //   updateBy: user?.userId,
        //   quotationLevelId: state.levelId,
        //   ModelNo: state.modelNo,
        //   Gst: state.gst,
        //   TotalAmount: state.totalAmount,
        //   transportationTypeId: state.transportationTypeId,
        // };

        let body = {
          id: quotationVendorItems?.id ?? 0,
          quotationRequestId: state.assetQuotationId,
          assetId: 0,
          vendorId: state.vendorId,
          quotationNo: "",
          quotationDate: new Date(),
          createdBy: user?.userId,
          updateBy: user?.userId,
          ModelNo: state.modelNo,

          quotationAmount: priceExcGst[0]?.quotationLineItemValue ?? 0,
          quotationLevelId: levelValue[0]?.id ?? 0,
          Gst: gst[0]?.quotationLineItemValue ?? 0,
          TotalAmount: totalAmount[0]?.quotationLineItemValue ?? 0,
          transportationTypeId: transportationTypeValue[0]?.id ?? 0,
          serviceTypeId: serviceTypeValue[0]?.id ?? 0,
          hiringQuantity: hiringQuantity[0]?.quotationLineItemValue ?? 0,
        };

        body.saveAssetQuotationVendorAttachmentRequest =
          assetAttachment.uploadedTemporaryAttachmentLst ?? [];
        var quotationVendorLineItemRequest = [];
        quotationVendorItems.forEach((data, index) => {
          var saveAssetQuotationVendorLineItem = {};
          saveAssetQuotationVendorLineItem.id = data?.id ?? 0;
          saveAssetQuotationVendorLineItem.rowId = data.rowId;
          saveAssetQuotationVendorLineItem.vendorId = state.vendorId;
          saveAssetQuotationVendorLineItem.quotationRequestId =
            state.assetQuotationId;
          saveAssetQuotationVendorLineItem.quotationLineItemId =
            data.quotationLineItemId;
          saveAssetQuotationVendorLineItem.quotationLineItemName =
            data.quotationLineItemName;
          saveAssetQuotationVendorLineItem.quotationLineItemValue =
            data.quotationLineItemValue;
          saveAssetQuotationVendorLineItem.createdBy = user?.userId;
          saveAssetQuotationVendorLineItem.updatedBy = user?.userId;
          quotationVendorLineItemRequest.push(saveAssetQuotationVendorLineItem);
        });
        body.saveAssetQuotationVendorLineItemRequest =
          quotationVendorLineItemRequest ?? [];
        //console.log(JSON.stringify(body));

        const response = await assetService.saveAssetQuotationVendor(body);

        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isSubmitted: false }));

        if (response?.isSuccess) {
          await getAssetQuotationVendor(state.assetQuotationId);
          await getQuotationAllVendorLineItems(state.assetQuotationId);
          await getAssetQuotation(state.assetQuotationId);
          await getAssetQuotationSub(state.assetQuotationId);
          handleOnCloseAssetQuotationVendorModal();
        }
      }

      // if (isValidAssetQuotationVendor()) {
      //   let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to add vendor details?</span>`;
      //   let isConfirmed = await askConfirmation(
      //     confirmationQuestion,
      //     "Yes",
      //     "No"
      //   );

      //   if (!isConfirmed) return;
      //   setState((prev) => ({ ...prev, isSubmitted: true }));

      //   let body = {
      //     id: assetQuotationVendorLst[0]?.id,
      //     quotationRequestId: state.assetQuotationId,
      //     assetId: 0,
      //     vendorId: state.vendorId,
      //     quotationNo: "",
      //     quotationDate: new Date(),
      //     quotationAmount: state.quotationCharges,
      //     createdBy: user?.userId,
      //     updateBy: user?.userId,
      //     quotationLevelId: state.levelId,
      //     ModelNo: state.modelNo,
      //     Gst: state.gst,
      //     TotalAmount: state.totalAmount,
      //     transportationTypeId: state.transportationTypeId,
      //   };

      //   body.SaveAssetQuotationVendorAttachmentRequest =
      //     assetAttachment.uploadedTemporaryAttachmentLst ?? [];
      //   const response = await assetService.saveAssetQuotationVendor(body);

      //   isConfirmed = await showResponseMessage(response);
      //   setState((prev) => ({ ...prev, isSubmitted: false }));

      //   if (response?.isSuccess) {
      //     await getAssetQuotationVendor(state.assetQuotationId);
      //     handleOnCloseAssetQuotationVendorModal();
      //     // await getAssetQuotation(state.assetQuotationId);
      //     // await getAssetQuotationSub(state.assetQuotationId);
      //   }
      // }
    } catch (error) {
      setState((prev) => ({ ...prev, isSubmitted: false }));
      console.log(error);
    }
  };

  const handleOnOpenAssetVendorDetailsModal = async (e, data) => {
    e.preventDefault();
    try {
      setState((prev) => ({
        ...prev,
        isVendorModalOpen: true,
      }));

      let err = { ...errors };
      err.vendorValidation = "";
      //err.quotationNoValidation = "";
      err.quotationChargesValidation = "";
      //err.quotationDateValidation = "";
      err.levelValidation = "";
      err.fileNameValidation = "";
      err.gstValidation = "";
      err.totalAmountValidation = "";
      err.modelNoValidation = "";
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseAssetQuotationVendorModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isVendorModalOpen: false,
        quotationNo: "",
        quotationDate: "",
        quotationCharges: 0,
        levelId: 0,
        levelName: "",
        vendorId: 0,
        modelNo: "",
        gst: 0,
        totalAmount: 0,
      }));

      setAssetAttachment((prev) => ({
        ...prev,
        documentTypeId: 0,
        documentTypeName: "",
        fileTypeName: "",
        fileName: "",
        fileUrl: "",
        fileData: "",
        extension: "",
        fileSize: 0,
        isIssueDateEnable: false,
        issueDate: "",
        isExpiryDateEnable: false,
        expiryDate: "",
        isReminderAlertEnable: false,
        reminderAlertDays: 0,
        remark: "",
        isUploaded: false,
        uploadedTemporaryAttachmentLst: [],
      }));

      setQuotationVendorLineItemLst([]);
    } catch (error) {
      console.log(error);
    }
  };
  const [events, setEvents] = useState([]);
  const clearEvents = useCallback(() => {
    setEvents([]);
  }, []);
  const renderGridCurrencyCell = (data) => {
    return (
      <div>
        <i className={CurrencyIcon.ruppesFormat}></i>
        &nbsp;
        {parseFloat(data.value).toFixed(PrecisionFormats[2])}
      </div>
    );
  };

  const logEvent = useCallback((eventName) => {
    setEvents((previousEvents) => [eventName, ...previousEvents]);
  });

  const onSaving = (data) => {
    setState((prev) => ({
      ...prev,
      rowInserted: data.data,
    }));
  };
  const onSaved = (data) => {
    setState((prev) => ({
      ...prev,
      rowInserted: data.data,
    }));
  };
  const onRowUpdating = (data) => {
    setState((prev) => ({
      ...prev,
      selectedItemKeys: data.newData,
    }));
  };
  const onInitNewRow = (data) => {
    if (tempRate.length >= 1) {
      let tempRateObject = tempRate[tempRate.length - 1];
      // let newMinkm = Number(tempRateObject.maxKm) + 1;
      // tempRate.push(data.data);
      // data.data.minkm = Number(newMinkm);
      // data.data.maxKm = 0;
    } else {
      if (tempRate.length > 0) {
        tempRate.push(data.data);
      }
    }
  };
  const onRowUpdated = (data) => {
    //this.Validation(data)
    setState((prev) => ({
      ...prev,
      selectedItemKeys: data.newData,
    }));
  };
  // const onRowInserting = (data) => {
  //   tempRate.push(data.data)
  // }
  const onRowInserted = (data) => {
    setState((prev) => ({
      ...prev,
      rowInserted: data.data,
    }));
  };
  const onEditCanceling = (data) => {
    setState((prev) => ({
      ...prev,
      rowInserting: data.data,
    }));
  };
  const onEditCanceled = (data) => {
    setState((prev) => ({
      ...prev,
      rowInserting: data.data,
    }));
  };

  const onRowRemoving = async (e) => {
    try {
      let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to delete this line item?</span>`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );

      if (!isConfirmed) return;
      setState((prev) => ({ ...prev }));

      let request = {};
      request.quotationRequestId = state.assetQuotationId;
      request.lineItemId = e.data.quotationLineItemId;

      const response = await assetService.deleteQuotationVendorLineItem(
        request
      );

      isConfirmed = await showResponseMessage(response);
      setState((prev) => ({ ...prev, isSubmitted: false }));
    } catch (error) {
      console.error("Delete failed:", error);
      e.cancel = true;
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div
            className="card-header p-2"
            style={{ backgroundColor: "#e3e7ff" }}
          >
            <div className="float-left">
              <h6 className="mb-0 mt-1">
                Quotation Indent No&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {state?.quotationIndentNo}
                </strong>
                &nbsp;&nbsp; From&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {user?.userDepartmentName}
                </strong>
                &nbsp;&nbsp;&nbsp;Date&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {moment(new Date()).format(
                    DefaultDateFormat.MomentDisplayDateTime24AMPFormat
                  )}
                </strong>
              </h6>
            </div>
            <div className="float-right">
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={async (e) => {
                  e.preventDefault();
                  navigate(
                    state.quotationTypeId === 1
                      ? "/RequestAssetPurchase"
                      : "/RequestAssetHire"
                  );
                }}
              >
                <span title="Cancel ">
                  <i className="fas fa-times" />
                  &nbsp;&nbsp;Cancel
                </span>
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={async (e) => {
                  e.preventDefault();
                  await handleOnSubmitAssetQuotationDetails(e);
                }}
                disabled={state.isSavingAsDraft}
              >
                <span title="Save As Draft">
                  <i
                    className={`fas fa-${
                      state.isSavingAsDraft
                        ? "spinner fa-spin"
                        : "file-signature"
                    }`}
                  />
                  &nbsp;&nbsp;Save As Draft
                </span>
              </button>
              &nbsp;&nbsp;
              {(state.statusId === AssetSubStatus.RequestForAssetServiceOrderInDraftMode ||
                state.statusId === AssetSubStatus.RequestForAssetServiceOrderBacktoDraft ||
                state.statusId === AssetSubStatus.RequestForAssetServiceOrderReCall) && (
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={async (e) => {
                    e.preventDefault();
                    await handleOnSubmitAssetQuotationApprovalDetails(e);
                  }}
                >
                  <span title="Send">
                    <i
                      className={`fas fa-${
                        state.isSending ? "spinner fa-spin" : "check"
                      }`}
                    />
                    &nbsp;&nbsp;Send for Approval
                  </span>
                </button>
              )}
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              {/* <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>
                    To &nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={userDropdown}
                    className={`form-control ${
                      errors.userValidation ? "is-invalid" : ""
                    }`}
                    classNamePrefix="select"
                    placeholder="Select user"
                    name="userDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.userId}
                    defaultValue={state.userId}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.userValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        userId: e?.selectedItem?.id ?? 0,
                      }));
                    }}
                  />
                  {errors.userValidation && (
                    <div className="text-danger">{errors.userValidation}</div>
                  )}
                </div>
              </div> */}
              <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>
                    To Project&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={toProjectDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select to project"
                    name="toProjectDropdown"
                    displayExpr="projectName"
                    valueExpr="id"
                    value={state.toProjectId}
                    defaultValue={state.toProjectId}
                    disabled={true}
                    showClearButton={true}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.toProjectValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        toProjectId: e?.selectedItem?.id ?? 0,
                        toProjectName: e?.selectedItem?.projectName ?? "",
                        toLocationName: e?.selectedItem?.location ?? "",
                      }));
                    }}
                  />
                  {errors.toProjectValidation && (
                    <div className="text-danger">
                      {errors.toProjectValidation}
                    </div>
                  )}
                </div>
              </div>
              {/* <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>
                    Category<span className="text-danger">*</span>
                  </label>
                  <div className="d-flex">
                    <SelectBox
                      dataSource={workflowCategoryDropdown}
                      className={`form-control ${errors.workflowCategoryValidation ? "is-invalid" : ""
                        }`}
                      classNamePrefix="select"
                      placeholder="Select category"
                      name="workflowCategoryDropdown"
                      displayExpr="name"
                      valueExpr="id"
                      value={state.workflowCategoryId}
                      defaultValue={state.workflowCategoryId}
                      showClearButton={true}
                      disabled={false}
                      searchEnabled={true}
                      onSelectionChanged={async (e) => {
                        let err = { ...errors };
                        err.workflowCategoryValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          workflowCategoryId: e?.selectedItem?.id ?? 0,
                        }));
                      }}
                    />
                  </div>
                  {errors.workflowCategoryValidation && (
                    <div className="text-danger">{errors.workflowCategoryValidation}</div>
                  )}
                </div>
              </div> */}
            </div>
            <hr />
            <div className="row">
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  {/* <label><small>Asset Description</small></label> */}
                  <p className="mb-0 textinfo">
                    Asset Description:{" "}
                    {assetQuotationSubDataSourceLst?.categoryName ?? ""} [
                    {assetQuotationSubDataSourceLst?.requiredQty ?? 0}]
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <div className="form-group mb-2">
                  {/* <label><small>Category / Sub Category</small></label> */}
                  <p className="mb-0 textinfo">
                    Category / Sub Category:{" "}
                    {assetQuotationSubDataSourceLst?.categoryName ?? ""} /{" "}
                    {assetQuotationSubDataSourceLst?.subCategoryName ?? ""}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-2">
                <div className="form-group mb-2">
                  {/* <label><small>Category / Sub Category</small></label> */}
                  <p className="mb-0 textinfo">
                    Duration (In Months):&nbsp;
                    {assetQuotationSubDataSourceLst?.monthNo ?? 0}
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <button
                    style={{ cursor: "pointer" }}
                    type="button"
                    title="Add"
                    className="btn btn-primary btn-sm"
                    onClick={async (e) => {
                      await handleOnOpenAssetVendorDetailsModal(e);
                    }}
                  >
                    <i className="fas fa-plus"></i>
                    &nbsp;&nbsp;Add Vendor
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <DataGrid
                    id="quotationAllVendorLineItemLst"
                    dataSource={quotationAllVendorLineItemLst}
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    showRowLines={true}
                    showColumnLines={true}
                    onRowPrepared={(e) => {
                      if (e.rowType === "header") {
                        e.rowElement.style.backgroundColor = "#f4f8c9ff";
                        const headerCells = e.rowElement.querySelectorAll("td");
                        headerCells.forEach((cell, index) => {
                          if (index > 0) {
                            var vendorName = cell.innerText.replace(/\s/g, "");
                            const label = document.createElement("span");
                            label.style.alignment = "right";
                            const deleteLink = document.createElement("a");
                            deleteLink.href = "#";
                            deleteLink.textContent = "Delete";
                            deleteLink.style.color = "#b68e2d";
                            deleteLink.style.marginLeft = "8px";
                            deleteLink.style.textDecoration = "underline";
                            deleteLink.onclick = async (ev) => {
                              ev.preventDefault();
                              var vendor = vendorDropdown?.filter(
                                (f) =>
                                  f.vendorName.replace(/\s/g, "") === vendorName
                              );
                              try {
                                if (vendor.length === 0) {
                                  let warningMessage = `Vendor not found`;
                                  let isConfirmed = await showWarningMessage(
                                    warningMessage,
                                    "Warning"
                                  );
                                  return;
                                }

                                let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to delete this vendor?</span>`;
                                let isConfirmed = await askConfirmation(
                                  confirmationQuestion,
                                  "Yes",
                                  "No"
                                );
                                if (!isConfirmed) return;
                                setState((prev) => ({ ...prev }));

                                let request = {};
                                request.quotationRequestId =
                                  state.assetQuotationId;
                                request.lineItemId = 0;
                                request.vendorId = vendor[0].id;

                                const response =
                                  await assetService.deleteQuotationVendorItem(
                                    request
                                  );

                                isConfirmed = await showResponseMessage(
                                  response
                                );

                                setState((prev) => ({
                                  ...prev,
                                  isSubmitted: false,
                                }));
                                if (response?.isSuccess) {
                                  getQuotationAllVendorLineItems();
                                }
                              } catch (error) {
                                console.error("Delete failed:", error);
                                e.cancel = true;
                              }
                            };

                            cell.appendChild(label);
                            cell.appendChild(deleteLink);
                          }
                        });
                      }
                    }}
                  ></DataGrid>
                </div>
              </div>
            </div>
            <div className="row displayNone">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <DataGrid
                    id="assetQuotationVendorLst"
                    dataSource={assetQuotationVendorLst}
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    showRowLines={true}
                    showColumnLines={true}
                    height={200}
                    onToolbarPreparing={(e) => {
                      e.toolbarOptions.items.unshift({
                        location: "before",
                        template: "toolbarAddTemplate",
                      });
                      e.toolbarOptions.items.unshift({
                        location: "before",
                        template: "toolbarContentTemplate",
                      });
                    }}
                  >
                    <Column
                      dataField="id"
                      caption=""
                      allowSorting={false}
                      allowSearch={false}
                      allowExporting={false}
                      allowFiltering={false}
                      width={50}
                      cellRender={(data) => {
                        return (
                          <button
                            style={{ cursor: "pointer" }}
                            type="button"
                            title="Delete"
                            className="btn btn-primary btn-sm-1"
                            onClick={async (e) => {
                              await handleOnDeleteAssetVendor(e, data.data.id);
                            }}
                          >
                            <Icon
                              icon="material-symbols-light:delete-outline"
                              width="18"
                              height="18"
                            />
                          </button>
                        );
                      }}
                    />
                    <Column
                      dataField="vendorName"
                      caption="Vendor Name"
                      allowSearch={true}
                    />
                    <Column
                      dataField="modelNo"
                      caption="Model No"
                      allowSearch={true}
                    />

                    <Column
                      dataField="quotationLevel"
                      caption="Quotation Level"
                      allowSearch={true}
                    />
                    <Column
                      dataField="quotationAmount"
                      caption="Price"
                      alignment={"center"}
                      allowSearch={true}
                      cellRender={renderGridCurrencyCell}
                    />
                    <Column
                      dataField="transportationType"
                      caption="Transportation Type"
                      allowSearch={true}
                    />
                    <Column
                      dataField="gst"
                      caption="Gst(%)"
                      alignment={"center"}
                      allowSearch={true}
                      cellRender={renderGridCurrencyCell}
                    />
                    <Column
                      dataField="totalAmount"
                      caption="Total Amount"
                      alignment={"center"}
                      allowSearch={true}
                      cellRender={renderGridCurrencyCell}
                    />
                    <Template
                      name="toolbarContentTemplate"
                      render={() => {
                        return (
                          <>
                            <div className="row">
                              <div className="col-12 col-lg-3">
                                <div className="form-group mb-2">
                                  {/* <label><small>Asset Description</small></label> */}
                                  <p className="mb-0 textinfo">
                                    Asset Description:{" "}
                                    {assetQuotationSubDataSourceLst?.categoryName ??
                                      ""}{" "}
                                    [
                                    {assetQuotationSubDataSourceLst?.requiredQty ??
                                      0}
                                    ]
                                  </p>
                                </div>
                              </div>
                              <div className="col-12 col-lg-4">
                                <div className="form-group mb-2">
                                  {/* <label><small>Category / Sub Category</small></label> */}
                                  <p className="mb-0 textinfo">
                                    Category / Sub Category:{" "}
                                    {assetQuotationSubDataSourceLst?.categoryName ??
                                      ""}{" "}
                                    /{" "}
                                    {assetQuotationSubDataSourceLst?.subCategoryName ??
                                      ""}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      }}
                    />
                    <Template
                      name="toolbarAddTemplate"
                      render={() => {
                        return (
                          <>
                            <button
                              style={{ cursor: "pointer" }}
                              type="button"
                              title="Add"
                              className="btn btn-primary btn-sm"
                              onClick={async (e) => {
                                await handleOnOpenAssetVendorDetailsModal(e);
                              }}
                            >
                              <i className="fas fa-plus"></i>
                              &nbsp;&nbsp;Add Vendor
                            </button>
                          </>
                        );
                      }}
                    />
                    <HeaderFilter visible={false} />
                    <Scrolling mode="Asset Quotation Vendor" />
                    <SearchPanel
                      visible={true}
                      highlightCaseSensitive={true}
                      width={240}
                      placeholder="Search..."
                    />
                  </DataGrid>
                </div>
              </div>
            </div>
            <div className="row displayNone">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="form-group">
                  <label>
                    {state.quotationTypeId === 1
                      ? "Purchase Content"
                      : "Hire Content"}
                  </label>
                  <style>
                    {`.jodit .jodit-status-bar__item:last-child { display: none !important; }`}
                  </style>
                  <JoditEditor
                    ref={editor}
                    value={content}
                    showCharsCounter={true}
                    tabIndex={1}
                    onBlur={(newContent) => setContent(newContent)}
                  />
                  {errors?.purchaseMessage && (
                    <span className="error invalid-feedback">
                      {errors?.purchaseMessage}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <label>
                    Note&nbsp;<span className="text-danger">*</span>
                  </label>
                  <TextArea
                    className="form-control"
                    placeholder="Enter note"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    height="35"
                    value={state.note}
                    onValueChanged={(e) => {
                      let err = { ...errors };
                      err.noteValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        note: e.value,
                      }));
                    }}
                  />
                  {errors.noteValidation && (
                    <div className="text-danger">{errors.noteValidation}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              {/* {assetRequestApproversByWorkflow?.length > 0 &&
                <div className="col-lg-4 col-md-12 col-sm-4">
                  <div className="form-group">
                    <label>Prepared By</label>
                    <TextBox
                      className="form-control"
                      placeholder="Enter name"
                      showClearButton={false}
                      value={
                        user?.firstName +
                        " " +
                        user?.lastName +
                        " (" +
                        user?.userDesignationName +
                        ")"
                      }
                      readOnly={true}
                    />
                  </div>
                </div>} */}
                {assetRequestApprovers?.[0]?.actionTypeId === 8 ? "" :
                  <>
                    <div className="col-lg-4 col-md-12 col-sm-4">
                      <div className='form-group'>
                        {assetRequestApprovers?.[0]?.actionTypeId === 8 ? ("") : (<label>Prepared By</label>)}
                        {assetRequestApprovers?.id ? (
                          <TextBox
                            className="form-control"
                            placeholder="Enter name"
                            showClearButton={false}
                            value={assetRequestApprovers?.fromUser + " (" + assetRequestApprovers?.fromUserDesignation + ")"}
                            readOnly={true}
                          />)
                          :
                          assetRequestApprovers?.[0]?.actionTypeId === 8 ? (
                            "")
                            :
                            (<TextBox
                              className="form-control"
                              placeholder="Enter name"
                              showClearButton={false}
                              value={user?.firstName + " " + user?.lastName + " (" + user?.userDesignationName + ")"}
                              readOnly={true}
                            />)
                        }
                      </div>
                    </div>
                  </>
                }
                {assetRequestApproversByWorkflow?.map((stage, index) => (
                  <div key={index} className="col-lg-4 col-md-12 col-sm-4 d-flex align-items-start">
                    <div className="w-100">
                      <label className="form-label">{stage?.actionTypeName}</label>
                      {stage?.approvers?.map((approver, i) => (
                        <input
                          key={i}
                          type="text"
                          className="form-control"
                          value={`${approver?.userName} (${approver?.designationName})`}
                          readOnly
                        />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
          </div>
        </div>
      </div>

      <Modal
        ariaHideApp={false}
        isOpen={state.isVendorModalOpen}
        onAfterOpen={async () => {
          await getLevelDropdown();
          await getVendorDropdown();
          let err = { ...errors };
          err.vendorValidation = "";
          //err.quotationNoValidation = "";
          err.quotationChargesValidation = "";
          //err.quotationDateValidation = "";
          err.levelValidation = "";
          err.gstValidation = "";
          err.totalAmountValidation = "";
          err.modelNoValidation = "";
          setErrors(err);
        }}
        className={"react-modal custom-modal-large-1"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Add Asset Attachment"
      >
        <div className="modal-header">
          <h6 className="modal-title">{`Add Asset Vendor`}</h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseAssetQuotationVendorModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            {/* <div className="col-12 col-lg-4">
              <div className="form-group">
                <label>
                  Vendor&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={vendorDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select vendor"
                  name="vendorDropdown"
                  displayExpr="vendorName"
                  valueExpr="id"
                  value={state.vendorId}
                  defaultValue={state.assignedVendorId}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.vendorValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      vendorId: e?.selectedItem?.id ?? 0,
                    }));
                    await getQuotationVendorLineItems(e?.selectedItem?.id ?? 0);
                  }}
                />
                {errors.vendorValidation && (
                  <div className="text-danger">{errors.vendorValidation}</div>
                )}
              </div>
            </div> */}
            {/* <div className="col-12 col-lg-3">
              <div className="form-group">
                <label>
                  Transportation Type&nbsp;
                  <span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={transportationTypeList}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select movement type"
                  name="modesOfTransportationLst"
                  displayExpr="name"
                  valueExpr="id"
                  value={state.transportationTypeId}
                  defaultValue={state.transportationTypeId}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.transportationTypeValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      transportationTypeId: e?.selectedItem?.id ?? 0,
                      transportationTypeName: e?.selectedItem?.name ?? "",
                    }));
                  }}
                />
                {errors.transportationTypeValidation && (
                  <div className="text-danger">
                    {errors.transportationTypeValidation}
                  </div>
                )}
              </div>
            </div> */}
          </div>

          <div className="row">
            <DataGrid
              ref={refDataGridColumnsConfig}
              id="gridContainer"
              dataSource={quotationVendorLineItemLst}
              keyExpr="rowId"
              allowColumnReordering={true}
              showBorders={true}
              showRowLines={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  {
                    location: "before",
                    template: "toolbarVendorDropdown",
                  },
                  {
                    location: "before",
                    template: "toolbarDurationTextTemplate",
                  }
                );
              }}
              onRowUpdating={(e) => {
                setState((prev) => ({
                  ...prev,
                  selectedItemKeys: e.newData,
                }));
              }}
              onInitNewRow={(e) => {
                e.data.isNewRow = true;
              }}
              onRowPrepared={(e) => {
                if (e.rowType === "data" && e.data?.isNewRow) {
                  e.rowElement.style.backgroundColor = "#f4f8c9ff"; // Light cyan
                }
                if (e.rowType === "data" && e.data?.isFixed === true) {
                  if (e.rowElement !== undefined) {
                    if (e.rowElement.querySelector !== undefined) {
                      const deleteButton =
                        e.rowElement.querySelector(".dx-command-edit");
                      if (deleteButton) {
                        deleteButton.style.display = "none";
                      }
                    }
                  }
                }
              }}
              onRowUpdated={(e) => {
                const rowId = e.key;
                setQuotationVendorLineItemLst((prev) => {
                  return prev.map((row) => {
                    if (row.rowId !== rowId) return row;
                    if (rowId > 0) {
                      const priceRow = prev.filter(
                        (e) => e.quotationLineItemName === "Price (Exc. GST)"
                      );
                      const gstRow = prev.filter(
                        (e) => e.quotationLineItemName === "GST%"
                      );
                      const totalRow = prev.filter(
                        (e) => e.quotationLineItemName === "Total Amount"
                      );

                      // const priceRow = prev[0];
                      // const gstRow = prev[1];
                      // const totalRow = prev[2];

                      const price =
                        parseFloat(priceRow[0]?.quotationLineItemValue) || 0;
                      const gst =
                        parseFloat(gstRow[0]?.quotationLineItemValue) || 0;
                      const total = price + (price * gst) / 100;

                      totalRow[0].quotationLineItemValue = total.toString();
                    }
                    return row;
                  });
                });

                setState((prev) => ({
                  ...prev,
                  selectedItemKeys: e.newData,
                }));
              }}
              onRowInserting={(e) => {}}
              onRowInserted={(e) => {}}
              onSaving={onSaving}
              onSaved={onSaved}
              onEditCanceling={onEditCanceling}
              onEditCanceled={onEditCanceled}
              //onRowRemoving={onRowRemoving}
              onEditorPreparing={(e) => {
                if (
                  e.parentType === "dataRow" &&
                  e.dataField === "quotationLineItemValue" &&
                  (e.row?.data?.quotationLineItemName === "Price (Exc. GST)" ||
                    e.row?.data?.quotationLineItemName === "GST%" ||
                    e.row?.data?.quotationLineItemName === "Total Amount" ||
                    e.row?.data?.quotationLineItemName === "Hiring Quantity")
                ) {
                  e.editorOptions.mode = "number";
                  e.editorOptions.validationRules = [
                    {
                      type: "required",
                      message: "This field is required",
                    },
                    {
                      type: "custom",
                      message: "Please enter a valid number",
                      validationCallback: (ruleParams) => {
                        const value = ruleParams.value;
                        return /^-?\d+(\.\d+)?$/.test(value);
                      },
                    },
                  ];
                }

                if (
                  e.parentType === "dataRow" &&
                  e.dataField === "quotationLineItemName" &&
                  e.row?.data?.isFixed === true
                ) {
                  e.editorOptions.readOnly = true;
                }

                if (
                  e.parentType === "dataRow" &&
                  e.dataField === "quotationLineItemValue" &&
                  e.row?.data?.quotationLineItemName === "Level" &&
                  e.row?.data?.isLookup === true
                ) {
                  e.editorName = "dxSelectBox"; // Required for lookup-style dropdown
                  e.editorOptions.dataSource = levelDropdown;
                  e.editorOptions.valueExpr = "name";
                  e.editorOptions.displayExpr = "name";
                }
                if (
                  e.parentType === "dataRow" &&
                  e.dataField === "quotationLineItemValue" &&
                  e.row?.data?.quotationLineItemName ===
                    "Transportation Type" &&
                  e.row?.data?.isLookup === true
                ) {
                  e.editorName = "dxSelectBox"; // Required for lookup-style dropdown
                  e.editorOptions.dataSource = transportationTypeList;
                  e.editorOptions.valueExpr = "name";
                  e.editorOptions.displayExpr = "name";
                }

                if (
                  e.parentType === "dataRow" &&
                  e.dataField === "quotationLineItemValue" &&
                  e.row?.data?.quotationLineItemName === "Service Type" &&
                  e.row?.data?.isLookup === true
                ) {
                  e.editorName = "dxSelectBox"; // Required for lookup-style dropdown
                  e.editorOptions.dataSource = serviceTypeList;
                  e.editorOptions.valueExpr = "name";
                  e.editorOptions.displayExpr = "name";
                }
              }}
            >
              <Paging enabled={true} />
              <Editing
                mode="cell"
                allowUpdating={true}
                allowDeleting={true}
                allowAdding={true}
              />
              <Column dataField="quotationLineItemName" caption="Item Name" />
              <Column
                dataField="quotationLineItemValue"
                caption="Item Description"
              />
              <Template
                name="toolbarVendorDropdown"
                render={() => (
                  <div style={{ minWidth: 350 }}>
                    {errors.vendorValidation && (
                      <div className="text-danger">
                        {errors.vendorValidation}
                      </div>
                    )}
                    <SelectBox
                      dataSource={vendorDropdown}
                      displayExpr="vendorName"
                      valueExpr="id"
                      value={state.vendorId}
                      defaultValue={state.assignedVendorId}
                      placeholder="Select Vendor"
                      showClearButton={true}
                      searchEnabled={true}
                      onValueChanged={async (e) => {
                        let err = { ...errors };
                        err.vendorValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          vendorId: e.value ?? 0,
                        }));
                        await getQuotationVendorLineItems(e.value); // Load grid data
                      }}
                    />
                  </div>
                )}
              />
              <Template
                name="toolbarDurationTextTemplate"
                render={() => (
                  <>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <strong>
                      Duration (In Months):&nbsp;&nbsp;
                      <span>
                        {assetQuotationSubDataSourceLst?.monthNo ?? 0}
                      </span>
                    </strong>
                  </>
                )}
              />
            </DataGrid>
            <br />
          </div>
          <div className="row">
            <div className="col-12 col-lg-2">
              <div className="form-group">
                <label
                  htmlFor="fileUpload"
                  className="btn btn-outline-primary mb-1"
                  style={{ cursor: "pointer", padding: "0.23rem 0.35rem" }}
                  title="Attachment"
                >
                  {" "}
                  <i class="fas fa-plus"></i> Attachment{" "}
                </label>
                <input
                  id="fileUpload"
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                {errors.fileNameValidation && (
                  <div className="text-danger">{errors.fileNameValidation}</div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-9">
              <div className="attachment-container">
                {assetAttachment?.uploadedTemporaryAttachmentLst?.map(
                  (file, idx) => (
                    <div key={idx} className="attachment-item">
                      <div
                        class="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className="attachment-name"
                          onClick={() => {
                            if (file?.filePath) {
                              window.open(file?.fileUrl, "_blank");
                            }
                          }}
                        >
                          {file?.fileName}
                        </div>
                        {file?.id === 0 && (
                          <button
                            className="btn pt-0 pb-0 pr-0"
                            onClick={() => handleFileRemove(idx)}
                          >
                            <i class="fas fa-times"></i>
                          </button>
                        )}
                      </div>
                      <div className="small">
                        {(file?.fileSize / 1024).toFixed(0)} kb
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnSaveAssetQuotationVendor(e);
            }}
            disabled={state.isSubmitted}
          >
            <span title="Submit">
              <i
                className={`fas fa-${
                  state.isSubmitted ? "spinner fa-spin" : "check"
                }`}
              />
              &nbsp;&nbsp;Submit
            </span>
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseAssetQuotationVendorModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>
    </>
  );
}
